// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"style_avatarContainer__3czfnYSMh4PQxwEme1dFEK"};